import { ButtonProps } from '../../atoms/Button';
import { TextProps } from '../../atoms/Text';


type GenericModalInternalProps = {
  text?: TextProps;
  button?: ButtonProps;
  text1?: TextProps;
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
};

type GenericModalPropsValues = {
  'Default': GenericModalInternalProps;
  'Critical': GenericModalInternalProps;
};

const propValues: GenericModalPropsValues = {
  'Default': {
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading3',
    },
    button: {
      style: 'Text',
      size: 'Small',
      type: 'Icon',
      colour: 'Base',
      loading: 'Default',
    },
    text1: {
      style: 'Regular',
      align: 'Left',
      colour: 'Default',
      type: 'Body1',
    },
    primaryButton: {
      style: 'Contained',
      size: 'Large',
      type: 'Text',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
    secondaryButton: {
      style: 'Outline',
      size: 'Large',
      type: 'Text',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
  },
  'Critical': {
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading3',
    },
    button: {
      style: 'Text',
      size: 'Small',
      type: 'Icon',
      colour: 'Base',
      loading: 'Default',
    },
    text1: {
      style: 'Regular',
      align: 'Left',
      colour: 'Default',
      type: 'Body1',
    },
    primaryButton: {
      style: 'Contained',
      size: 'Large',
      type: 'Text',
      colour: 'Critical',
      loading: 'Default',
    },
    secondaryButton: {
      style: 'Outline',
      size: 'Large',
      type: 'Text',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
  },
};

const getProps = (type: string): GenericModalInternalProps => {
  const values: GenericModalInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
